module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "split-event"
  }, [(_vm.showModal) ? _c('AppModal', {
    attrs: {
      "submitTxt": _vm.i18n[_vm.locale].btn,
      "isShowFooter": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h1', {
    attrs: {
      "slot": "header"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].split) + " " + _vm._s(_vm.lesson.title) + ", " + _vm._s(_vm._f("showDate")(_vm.lesson.start)))]), _vm._v(" "), _c('div', {
    staticClass: "form",
    attrs: {
      "slot": "body"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "origin-lesson"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].original_lesson))]), _vm._v(" "), _c('div', {
    staticClass: "flex border pad-10 relative"
  }, [_c('p', [_vm._v(_vm._s(_vm.lesson.title))]), _vm._v(" "), _c('div', {
    staticClass: "lesson_times"
  }, [_c('div', [_vm._v(", kl. " + _vm._s(_vm._f("LT")(_vm.lesson.start)))]), _vm._v(" "), _c('div', {
    staticClass: "lesson_times__seperator"
  }, [_vm._v(" -")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("LT")(_vm.lesson.end)))])]), _vm._v(" "), _c('div', {
    staticClass: "marg-10-left"
  }, [_vm._v("\n            (" + _vm._s(_vm.i18n[_vm.locale].duration) + ": " + _vm._s(_vm.oldDuration) + " " + _vm._s(_vm.i18n[_vm.locale].minutes) + ")\n          ")])])]), _vm._v(" "), _c('h3', {
    staticClass: "marg-24-top flex align-center"
  }, [_c('span', {
    staticClass: "icon-clock"
  }), _c('span', {
    staticClass: "marg-5-left"
  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale].when_is_the_split) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex align-center split-input-wrapper"
  }, [_c('timeInput', {
    staticClass: "split-lesson-input",
    attrs: {
      "refs": "timeinput",
      "id": "focus",
      "date": _vm.newLessonStart
    },
    on: {
      "changed": _vm.setStartTime
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].split_lessons) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "flex border pad-10 marg-5-bottom relative"
  }, [_c('p', [_vm._v(_vm._s(_vm.lesson.title))]), _vm._v(" "), _c('div', {
    staticClass: "lesson_times"
  }, [_c('div', [_vm._v(", " + _vm._s(_vm._f("LT")(_vm.lesson.start)))]), _vm._v(" "), _c('div', {
    staticClass: "lesson_times__seperator"
  }, [_vm._v(" -")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("LT")(_vm.newLessonStart)))])]), _vm._v(" "), _c('div', {
    staticClass: "marg-10-left"
  }, [_vm._v("\n          (" + _vm._s(_vm.i18n[_vm.locale].duration) + ": " + _vm._s(_vm.lessonDuration) + " " + _vm._s(_vm.i18n[_vm.locale].minutes) + ")\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex border pad-10 relative"
  }, [_c('div', {
    staticClass: "lesson__border-left",
    staticStyle: {
      "{borderColor": "lesson.color}"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.lesson.title))]), _vm._v(" "), _c('div', {
    staticClass: "lesson_times"
  }, [_c('div', [_vm._v(", " + _vm._s(_vm._f("LT")(_vm.newLessonStart)))]), _vm._v(" "), _c('div', {
    staticClass: "lesson_times__seperator"
  }, [_vm._v(" -")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("LT")(_vm.lesson.end)))])]), _vm._v(" "), _c('div', {
    staticClass: "marg-10-left"
  }, [_vm._v("\n          (" + _vm._s(_vm.i18n[_vm.locale].duration) + ": " + _vm._s(_vm.newLessonDuration) + " " + _vm._s(_vm.i18n[_vm.locale].minutes) + ")\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "italic"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].everything_will_be_cloned))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer modal-footer__flex"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d630828!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/SubsEventSplit.vue
// module id = 1602
// module chunks = 1